export const languages : {[propKey: string]: string} = {
  'EN': 'English',
  'BG': 'Български',
  'CS': 'Čeština',
  'DA': 'Dansk',
  'DE': 'Deutsch',
  'EL': 'Ελληνικά',
  'ES': 'Español',
  'ET': 'Eesti keel',
  'FI': 'suomi',
  'FR': 'Francais',
  'HR': 'Hrvatska',
  'HU': 'Magyar',
  'IT': 'Italiano',
  'LT': 'Lietuva',
  'LV': 'Latvian',
  'NL': 'Nederlands',
  'NO': 'Norsk',
  'PL': 'Polski',
  'PT': 'Português',
  'RO': 'Română',
  'SK': 'Slovenská',
  'SL': 'slovenščina',
  'SV': 'Svenska'
}

export const  vehicleModels = {
  "smart #1" : "1",
  "smart #3" : "3",
  "smart #5" : "5",
}

export const pdfPrefixes: { [propKey: string]: string } = {
  "1" : "smart_#1__SUV_2022_5d_Electric_",
  "3" : "smart_#3__Hatchback_2023_5d_Electric_",
  "5" : "smart_#5__SUV_2025_5d_Electric_"
}

export const modelLanguages: { [modelId: string]: string[] } = {
  "1": ['EN', 'DE', 'FR', 'IT', 'ES', 'NL', 'PL', 'RO', 'SV', 'HR', 'DA', 'FI', 'EL', 'LV', 'LT', 'HU', 'NO', 'PT', 'SK', 'SL', 'BG', 'CS', 'ET'], 
  "3": ['EN', 'DE', 'FR', 'IT', 'ES', 'NL', 'PL', 'RO', 'SV', 'HR', 'DA', 'FI', 'EL', 'LV', 'LT', 'HU', 'NO', 'PT', 'SK', 'SL', 'BG', 'CS', 'ET'],             
  "5": ['EN', 'DE', 'FR', 'IT', 'ES', 'NL', 'PL', 'RO', 'SV', 'HR', 'DA', 'FI', 'EL', 'LV', 'LT', 'HU', 'NO', 'PT', 'SK', 'SL', 'BG', 'CS', 'ET']                   
}

export function getAvailableLanguages(modelId: string): {[propKey: string]: string} {
  const availableLanguages: {[propKey: string]: string} = {};
  const supportedLangs = modelLanguages[modelId] || [];
  
  supportedLangs.forEach(langCode => {
    if (languages[langCode]) {
      availableLanguages[langCode] = languages[langCode];
    }
  });
  
  return availableLanguages;
}